<div class="data-table" *ngIf="!noDataFound; else noDataFoundSection">
  <div class="search-box" *ngIf="showSearchColumn">
    <input
      type="text"
      (input)="applyFilter()"
      placeholder="Search..."
      [(ngModel)]="searchQuery"
    />
  </div>

  <table>
    <thead>
      <tr>
        <th
          *ngFor="let column of columns"
          (click)="sortData(column.key, column.order)"
        >
          {{ column.label }}
          <span *ngIf="column.order === 'asc'">&uarr;</span>
          <span *ngIf="column.order === 'desc'">&darr;</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of displayedData">
        <td *ngFor="let column of columns">
          <ng-container *ngIf="column.type === 'date'; else textContent">
            {{ row[column.key] | date }}
            <!-- <p>date</p> -->
          </ng-container>
          <ng-template #textContent>
            <ng-container *ngIf="column.type === 'html'; else buttonsSection">
              <span [innerHTML]="row[column.key]"></span>
              <!-- <p>html</p> -->
            </ng-container>
            <ng-template #buttonsSection>
              <ng-container *ngIf="column.type === 'buttons'; else plainText">
                <ng-container *ngFor="let button of column.buttons">
                  <!-- *ngIf="button.condition" -->
                  <button
                    [ngClass]="button.class"
                    (click)="buttonsClick(row, button.identifier)"
                  >
                    {{ button.label }}
                  </button>
                </ng-container>
              </ng-container>
              <ng-template #plainText>
                {{ row[column.key] }}
                <!-- <p>plain text</p> -->
              </ng-template>
            </ng-template>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="pagination">
    <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 0">
      <i class="feather icon-arrow-left icon-md"></i>
    </button>
    <span>{{ currentPage + 1 }}</span>
    <button
      (click)="goToPage(currentPage + 1)"
      [disabled]="(currentPage + 1) * pageSize >= data.length"
    >
      <i class="feather icon-arrow-right icon-md"></i>
    </button>
    <button (click)="goToPage(0)" [disabled]="currentPage === 0">
      <i class="feather icon-chevrons-left icon-md"></i>
    </button>
    <button
      (click)="goToPage(data.length / pageSize - 1)"
      [disabled]="(currentPage + 1) * pageSize >= data.length"
    >
      <i class="feather icon-chevrons-right icon-md"></i>
    </button>

    <span
      >{{ pageSize * currentPage + 1 }} -
      {{ pageSize * (currentPage + 1) }}</span
    >
    <select (change)="changePageSize($event)">
      <option
        *ngFor="let size of pageSizeOptions"
        [value]="size"
        [selected]="size === pageSize"
      >
        {{ size }}
      </option>
    </select>
    <span>Records: {{ data.length }}</span>
  </div>

  <div *ngIf="(currentPage + 1) * pageSize < totalItems" class="load-more">
    <button (click)="loadMoreData()">Load More</button>
  </div>
</div>
<ng-template #noDataFoundSection>
  <div class="text-center no-result-entry">
    <p>No data found</p>
  </div>
</ng-template>
